import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { TEXT } from '../Colors';
import { BODY, HEADING_01, HEADING_02, HEADING_03, MINI_HEADER, SUBTITLE } from '../Fonts';

const useStyles = makeStyles({
    base: {
        color: TEXT,
    },
    body: {
        font: BODY
    },
    subtitle: {
        font: SUBTITLE
    },
    mini_header: {
        font: MINI_HEADER
    },
    heading_01: {
        font: HEADING_01
    },
    heading_02: {
        font: HEADING_02
    },
    heading_03: {
        font: HEADING_03
    }
});

interface LabelProps {
    typography: 'body' | 'subtitle' | 'mini_header' | 'heading_01' | 'heading_02' | 'heading_03',
    children?: string,
    hidden?: boolean
}

export const Label: React.FunctionComponent<LabelProps> = (props) => {
    const classes = useStyles();

    // "stylingClassName" is used for "styled components" extensions. It is hidden from the developer.
    const stylingClassName = (props as any).className ? (props as any).className : '';

    const className = `${classes.base} ${classes[props.typography]} ${stylingClassName}`;

    return (
        <span className={className} hidden={props.hidden}>
            {props.children}
        </span>
    );
}